import { Tab } from "@chakra-ui/react";
import { HypotheticalTabProps } from "features/financial-reporting/tabs/HypotheticalTabProps";
import { useHypotheticalWaterfallNavBreakdownRetrieveSuspense } from "gen/endpoints/financial-reporting/financial-reporting";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { PageTabBody } from "shared/components/layout/PageTabBody";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxBody } from "shared/components/table/box/TableBoxBody";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { TableBoxTabs } from "shared/components/table/box/TableBoxTabs";
import { DataTable } from "shared/components/table/data/DataTable";
import { DataTableBoxActions } from "shared/components/table/data/DataTableBoxActions";

export const HypotheticalTabInvestorNav: React.FC = () => {
  const { fundFamilyId, hypotheticalWaterfallId, endOfPeriodReportId } =
    useOutletContext<HypotheticalTabProps>();
  const { t } = useTranslation(["financialReporting", "common"]);
  const { data: hypotheticalNavData } =
    useHypotheticalWaterfallNavBreakdownRetrieveSuspense(
      fundFamilyId,
      endOfPeriodReportId,
      hypotheticalWaterfallId,
    );
  const [selectedTab, setSelectedTab] = useState(0);

  const tableData = [
    hypotheticalNavData.qtd_table_data,
    hypotheticalNavData.ytd_table_data,
    hypotheticalNavData.itd_table_data,
  ];
  return (
    <PageTabBody>
      <TableBox isFullWidth={true}>
        <TableBoxHeader>
          <TableBoxTabs index={selectedTab} onChange={setSelectedTab}>
            <Tab>{t("financialReporting:investorNavTable.tabs.qtd")}</Tab>
            <Tab>{t("financialReporting:investorNavTable.tabs.ytd")}</Tab>
            <Tab>{t("financialReporting:investorNavTable.tabs.itd")}</Tab>
          </TableBoxTabs>
          <DataTableBoxActions />
        </TableBoxHeader>
        <TableBoxBody>
          <DataTable data={tableData[selectedTab]} />
        </TableBoxBody>
      </TableBox>
    </PageTabBody>
  );
};
